import { BottomSheet } from '../design-system/feedback/BottomSheet';
import { EMOJI_GROUPS, readRecentReactions } from '../../lib/emojiSet';

/** "+" on the reaction bar: a sheet of common emojis, recent ones first. */
export function EmojiSheet({ mine, onPick, onClose }: { mine?: string; onPick: (emoji: string) => void; onClose: () => void }) {
  const recents = readRecentReactions();
  const cell = (emoji: string) => (
    <button
      key={emoji}
      type="button"
      onClick={() => onPick(emoji)}
      aria-label={`React with ${emoji}`}
      aria-pressed={mine === emoji}
      className={`h-11 rounded-lg flex items-center justify-center text-[length:calc(26px*var(--text-scale))] ${mine === emoji ? 'bg-gold/20' : 'active:bg-app-border'}`}
    >
      {emoji}
    </button>
  );
  return (
    <BottomSheet title="React" ariaLabel="Choose a reaction" onClose={onClose}>
      <div className="px-4 pb-6 flex flex-col gap-3">
        {recents.length > 0 && (
          <section>
            <h3 className="text-xs font-medium text-app-muted mb-1">Recent</h3>
            <div className="grid grid-cols-8">{recents.map(cell)}</div>
          </section>
        )}
        {EMOJI_GROUPS.map((g) => (
          <section key={g.key}>
            <h3 className="text-xs font-medium text-app-muted mb-1">{g.label}</h3>
            <div className="grid grid-cols-8">{g.emojis.map(cell)}</div>
          </section>
        ))}
      </div>
    </BottomSheet>
  );
}
